import React from 'react'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { cn, type UtilityClassNames } from '@s4l/utility-css'
import styles from './index.module.css'

const GOOGLE_PLAY_DARK =
  'https://static.stayforlong.com/web/images/260116-google-play-store-dark.svg'
const GOOGLE_PLAY_LIGHT =
  'https://static.stayforlong.com/web/images/260116-google-play-store-light.svg'
const APP_STORE_DARK = 'https://static.stayforlong.com/web/images/260116-app-store-dark.svg'
const APP_STORE_LIGHT = 'https://static.stayforlong.com/web/images/260116-app-store-light.svg'

const ASSET_MAP = {
  googlePlay: {
    dark: GOOGLE_PLAY_DARK,
    light: GOOGLE_PLAY_LIGHT,
  },
  appStore: {
    dark: APP_STORE_DARK,
    light: APP_STORE_LIGHT,
  },
} as const

export const STORE_URLS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.stayforlong.app',
  appStore: 'https://apps.apple.com/us/app/stayforlong/id6755036861',
} as const

export type StoreDownloadButtonStore = 'googlePlay' | 'appStore'
export type StoreDownloadButtonTheme = 'dark' | 'light'

export interface StoreDownloadButtonProps {
  className?: UtilityClassNames
  store: StoreDownloadButtonStore
  theme?: StoreDownloadButtonTheme
}

function StoreDownloadButton({
  className,
  store = 'googlePlay',
  theme = 'dark',
}: Readonly<StoreDownloadButtonProps>) {
  const href = STORE_URLS[store]
  const asset = ASSET_MAP[store][theme]
  const label = store === 'googlePlay' ? 'Google Play' : 'App Store'

  return (
    <a
      className={cn(styles.button, className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
    >
      <img className={styles.image} src={asset} alt={label} />
    </a>
  )
}

StoreDownloadButton.displayName = 'StoreDownloadButton'
export default withErrorBoundary(StoreDownloadButton)
